import { StepItems } from './hipaa-types';

/** The initial state data for each step of the HIPAA wizard. */
export const hipaaSetupSteps: StepItems = {
  0: {
    name: 'Unexpected error',
    bodyTitle: 'An unexpected error occurred',
    numberOfFields: 0,
    hideInSteps: true,
    terminatingStep: true,
    buttonText: 'Close'
  },
  1: { name: 'What to expect', bodyTitle: 'What to expect', numberOfFields: 0, buttonText: 'Get started' },
  2: { name: 'Verify your email', bodyTitle: 'Verify your account email address', numberOfFields: 3, startDisabled: true, buttonText: 'Next' },
  3: { name: 'Complete the BAA', bodyTitle: 'Complete the Business Associate Agreement (BAA)', numberOfFields: 7, startDisabled: true, buttonText: 'Next' },
  4: { name: 'Review and sign', bodyTitle: 'Review and submit your BAA', numberOfFields: 0, /*startDisabled: true, */ buttonText: 'Submit' },
  5: { name: 'Initiate processing', bodyTitle: 'Initiate processing', numberOfFields: 0, buttonText: 'Process' },
  6: { name: 'Confirmation', bodyTitle: 'Confirmation', numberOfFields: 0, buttonText: 'Close', terminatingStep: true, hideInSteps: true }
};
